// Dependencies
import React from 'react';

// Assets
import './UserLocation.css';


const UserLocation = ({ text }) => (
  <div className="UserLocation">
    <img src="/assets/icons/circle.svg" alt={text} title={text} />
  </div>
);

export default UserLocation;
